import { render, staticRenderFns } from "./jjsList.vue?vue&type=template&id=ce238a8c&scoped=true"
import script from "./jjsList.vue?vue&type=script&lang=js"
export * from "./jjsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce238a8c",
  null
  
)

export default component.exports